export const useImageUrl = () => {
    /**
     * Get the appropriate image URL - prioritizing R2 URL if available
     * @param image - The image object from Airtable
     * @returns The URL to use for the image
     */
    const getImageUrl = (image: any): string => {
        if (!image) return '';
        
        // First priority: Use R2 URL if available
        if (image.r2Url) {
            return image.r2Url;
        }
        
        // Second priority: Use Airtable thumbnail if available
        if (image.thumbnails?.large?.url) {
            return image.thumbnails.large.url;
        }
        
        // Fallback: Use direct URL
        return image.url || '';
    };

    /**
     * Get the best image URL from an array of images
     * @param images - Array of images
     * @param index - Index of the image to get (default: last image)
     * @returns The URL to use for the image
     */
    const getImageFromArray = (images: any[], index?: number): string => {
        if (!images || !images.length) return '';
        
        const targetIndex = index !== undefined ? index : images.length - 1;
        const image = images[targetIndex];
        
        return getImageUrl(image);
    };

    return {
        getImageUrl,
        getImageFromArray
    };
};